import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import { getUser } from "../../../Utils/externalFunctions";
import DataTable from "react-data-table-component";
import { formatRP } from "../../../Utils/externalFunctions";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { useThemeContext } from "../../../Context/ThemeContext";
import { filterSearch } from "../../../Utils/FilterItems";
import { getRencImp } from "../services";

const StepSatu = ({ nextStep, formRealokasi, setSelectedRencImp }) => {
  const axiosInstance = useAxios();

  const [rencImpList, setRencImpList] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filteredItems, setFilteredItems] = useState([]);

  const [pending, setPending] = useState(false);

  const { themeContext } = useThemeContext();

  const sumberDanaLookup = {
    51: "51 - BP",
    61: "61 - Non BP",
    81: "81 - Dana Khusus",
  };

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      setPending(true);

      const { data: rencImpData } = await getRencImp(axiosInstance).finally(
        () => {
          setPending(false);
        }
      );
      setRencImpList(rencImpData);
      setFilteredItems(rencImpData);
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    formRealokasi.diajukan_oleh = getUser();
  }, [formRealokasi.nilai_realokasi]);

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const handleFilter = (e) => {
    const searchCategories = [
      "nm_org",
      "kd_org",
      "nm_akun",
      "kd_akun",
      "nm_keg",
      "kd_keg",
      "nm_jk",
    ];

    const filteredItems = rencImpList.filter(
      filterSearch(searchCategories, e.target.value)
    );

    setFilteredItems(filteredItems);
    setFilterText(e.target.value);
    return filteredItems;
  };

  const getSubHeaderComponent = () => {
    return (
      <FilterComponent
        onFilter={handleFilter}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  };

  const daftarRencImp = [
    {
      name: "DPSJ",
      selector: (row) => row.nm_org,
      sortable: true,
      wrap: true,
    },
    {
      name: "Sumber Dana",
      selector: (row) =>
        sumberDanaLookup[row.id_sumber_dana]
          ? sumberDanaLookup[row.id_sumber_dana]
          : row.id_sumber_dana,
      sortable: true,
    },
    {
      name: "Kegiatan",
      selector: (row) => row.kd_keg + "-" + row.nm_keg,
      sortable: true,
      wrap: true,
    },
    {
      name: "Akun",
      selector: (row) => row.kd_akun + "-" + row.nm_akun,
      sortable: true,
      wrap: true,
    },
    {
      name: "Sisa Anggaran (Rp)",
      selector: (row) => parseInt(row.anggaran_tersisa),
      sortable: true,
      format: (row) => formatRP(row.anggaran_tersisa),
    },

    {
      name: "Operasi",
      cell: (row) => (
        <Button onClick={() => setSelectedRencImp(row) & nextStep()}>
          Ajukan Realokasi
        </Button>
      ),
    },
  ];

  return (
    <DataTable
      columns={daftarRencImp}
      data={filteredItems}
      pagination
      paginationResetDefaultPage={resetPaginationToggle}
      selectableRowsHighlight
      highlightOnHover
      subHeader
      subHeaderComponent={getSubHeaderComponent()}
      subHeaderAlign="right"
      persistTableHead
      progressPending={pending}
      theme={themeContext}
    />
  );
};

export default StepSatu;
